import { releaseWeek } from '@/mocks/mangas';

export default function Calendar() {
  return (
    <section id="calendar" className="bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-sm font-medium text-secondary-900">
            <i className="ri-calendar-check-line" /> 漫画更新日历
          </span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">本周追更安排一览</h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-600">
            按星期规划你的追更时间，提前掌握每部作品的更新节奏
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-7">
          {releaseWeek.map((d) => (
            <div
              key={d.day}
              className="rounded-lg border border-background-200 bg-background-50 p-4"
            >
              <div className="mb-3 flex items-center justify-between">
                <h3 className="text-sm font-bold text-foreground-950">{d.day}</h3>
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-secondary-100 text-xs font-medium text-secondary-900">
                  {d.items.length}
                </span>
              </div>
              <div className="flex flex-col gap-2.5">
                {d.items.map((m) => (
                  <div key={m.id} className="flex items-center gap-2.5">
                    <img
                      src={m.cover}
                      alt={m.title}
                      className="h-10 w-10 shrink-0 rounded-md object-cover object-top"
                    />
                    <div className="min-w-0">
                      <p className="truncate text-xs font-medium text-foreground-800">{m.title}</p>
                      <p className="truncate text-[11px] text-foreground-500">{m.latestChapter}</p>
                    </div>
                  </div>
                ))}
                {d.items.length === 0 && (
                  <p className="text-xs text-foreground-400">暂无更新</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}